module.exports = __webpack_public_path__ + "img/button-dark-02.940aa183.png";